import { numberToPrettyString, plural } from '@cian/utils';

import { isCommercialMultiAds } from './isCommercialMultiAds';
import { IOffer } from '../../../../types/offer';
import { getCommercialBuildingClass } from '../getCommercialBuildingClass';

const MIDDLE_DOT = '・';
const FLOOR_PLURAL: [string, string, string] = ['этаж', 'этажа', 'этажей'];

function getTotalAreaValue(offer: IOffer): number | undefined {
  const explicit = Number(offer.totalArea);

  if (Number.isFinite(explicit) && explicit > 0) {
    return explicit;
  }

  const sum = (offer.areaParts ?? []).reduce((acc, part) => acc + (part.area ?? 0), 0);

  return sum > 0 ? sum : undefined;
}

export function getMultiAdsAvailability(offer: IOffer): string | undefined {
  if (!isCommercialMultiAds(offer)) {
    return undefined;
  }

  const parts: string[] = [];

  const totalArea = getTotalAreaValue(offer);
  if (totalArea) {
    parts.push(`Доступно ${numberToPrettyString(Math.round(totalArea * 10) / 10)} м²`);
  }

  const floorsCount = offer.building?.floorsCount;
  if (floorsCount) {
    parts.push(`${floorsCount} ${plural(floorsCount, FLOOR_PLURAL)}`);
  }

  const buildingClass = getCommercialBuildingClass(offer);
  if (buildingClass) {
    parts.push(buildingClass);
  }

  if (parts.length === 0) {
    return undefined;
  }

  return parts.join(MIDDLE_DOT);
}
